import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractFrontJacket from "../FrontJacket";

class FrontJacket extends AbstractFrontJacket {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-front-jackets-ipr';
  }
}

export default FrontJacket;
